module.exports = "https://la-static.vkplay.ru/promo/newstart/img/reaper.8b76e754.png";